
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { SpeakersBlockLayout, SpeakersBlockListItemModel, SpeakersBlockSettingsModel } from 'fourwaves-shared';
import SpeakersBlockListItem from './SpeakersBlockListItem.vue';

@Component({
  components: {
    SpeakersBlockListItem,
  },
})
export default class SpeakersBlockList extends Vue {
  @Prop({ type: Array, required: true }) readonly items!: SpeakersBlockListItemModel[];
  @Prop({ type: Object, required: true }) readonly settings!: SpeakersBlockSettingsModel;

  get rootStyles(): Record<string, number | string> {
    return { '--max-row': this.settings.layout === SpeakersBlockLayout.List ? 1 : this.settings.maxItemsInRow };
  }
}
